import { z } from 'zod';
import { UserProfileId } from '../entities/traveler/user_profile.js';

/** A flag do feature-flag-service (`currentFeatures(system: USER_APP)`) que libera, por cliente,
 *  as corridas 99 em lote para o gestor. O customer-api repassa só as listadas aqui. */
export const MOBILITY_99_BATCH_FEATURE_FLAGS = ['mobility99_batch'] as const;

/** `business.users.profileId` de quem monta lote: OWNER (0), MASTER (1), ADMIN (2), MANAGER (3). */
const MANAGER_PROFILE_IDS: ReadonlySet<number> = new Set([
  UserProfileId.OWNER,
  UserProfileId.MASTER,
  UserProfileId.ADMIN,
  UserProfileId.MANAGER,
]);

/** Se o perfil de CASA monta lote; `null` = desconhecido, nega. */
export function isRideBatchManagerProfile(profileId: number | null): boolean {
  return profileId !== null && MANAGER_PROFILE_IDS.has(profileId);
}

export interface RideBatchesAccessInput {
  /** `business.users.profileId` do gestor (o de CASA); `null` = desconhecido. */
  profileId: number | null;
  /** `currentFeatures(USER_APP)` filtradas no cliente efetivo; `null` = não resolvido. */
  featureFlags: readonly string[] | null;
}

/** `/me.rideBatches`. `clientName` é o nome do cliente efetivo, o MESMO que o BFF manda na
 *  criação do lote (a prévia do WhatsApp usa). */
export const RideBatchesEntrySchema = z
  .object({ allowed: z.boolean(), clientName: z.string().min(1).optional() })
  .strict();
export type RideBatchesEntry = z.infer<typeof RideBatchesEntrySchema>;

/** Se o gestor monta lote: perfil de gestão e a flag. Perfil ou flags desconhecidos negam. */
export function rideBatchesEntry(input: RideBatchesAccessInput): RideBatchesEntry {
  const { profileId, featureFlags } = input;
  if (!isRideBatchManagerProfile(profileId) || featureFlags === null) {
    return { allowed: false };
  }
  return {
    allowed: MOBILITY_99_BATCH_FEATURE_FLAGS.every((flag) => featureFlags.includes(flag)),
  };
}
